import { render, staticRenderFns } from "./UserBadge.vue?vue&type=template&id=24360e2a&scoped=true"
import script from "./UserBadge.vue?vue&type=script&lang=js"
export * from "./UserBadge.vue?vue&type=script&lang=js"
import style0 from "./UserBadge.vue?vue&type=style&index=0&id=24360e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24360e2a",
  null
  
)

export default component.exports